export const formatPrice = (value: number) => new Intl.NumberFormat('ru-RU').format(value)

export const unformatPrice = (value: string) => Number(value.replace(/\D/g, ''))
